import MainService from './main'
import UserService from './user'
import familyService from './family'
import promotionService from './promotion'
import loyaltyProgramService from './loyalty'
import ProductService from './product'
import CartService from './cart'
import CardService from './card'
import FormService from './form'
import LocationService from './location'
import SocialService from './social'

export default {
  MainService,
  UserService,
  familyService,
  promotionService,
  loyaltyProgramService,
  ProductService,
  CartService,
  CardService,
  FormService,
  LocationService,
  SocialService
}

